import { render } from "./CgvView.vue?vue&type=template&id=0c67758e"
import script from "./CgvView.vue?vue&type=script&lang=js"
export * from "./CgvView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__